import React from 'react';
import {selectUserFields, UserField} from '@packages/systems/users/flux';
import TooltipTrigger from '@packages/systems/design-system/TooltipTrigger';
import {Checkbox} from '@packages/systems/design-system/Checkbox';
import {Note} from '@packages/systems/spring';
import {useDesignerSelector} from '@packages/systems/designer/flux';

const getUserFieldData = (fieldId: string, customFields: Array<UserField>) => {
  if (!fieldId) return null;
  return customFields.find((field) => field.id === fieldId) ?? null;
};

export const UserFormRequired = ({fieldId}: {fieldId: string}) => {
  const customUserFields = useDesignerSelector(selectUserFields);
  const userField = getUserFieldData(fieldId, customUserFields);

  return (
    <>
      {userField && (
        <>
          <TooltipTrigger
            content={
              userField.required
                ? 'Input from the end user must be stored as part of their account information.'
                : 'Input from the end user is not required information.'
            }
            data-automation-id="usys-form-text-field-required-tooltip"
            alternate
          >
            <Checkbox
              label="Required"
              checked={userField?.required}
              style={{width: 'fit-content'}}
              data-automation-id="usys-form-text-field-required"
              disabled
            />
          </TooltipTrigger>
          <Note
            data-automation-id="usys-form-text-field-required-note"
            colorVariant="default"
            hasIcon={false}
          >
            This input is bound to the &quot;{userField.name}&quot; field within
            User Accounts.
          </Note>
        </>
      )}
    </>
  );
};
